import { useTranslation } from 'react-i18next';
import UnpublishedIcon from '@mui/icons-material/UnpublishedOutlined';
import { Container, Paper } from '@mui/material';
import { WStateLayout } from '@wareclouds/wareclouds-ui';

export default function NoPendingOrders() {
  const { t } = useTranslation(['description', 'title']);

  return (
    <Paper sx={{ p: 2 }}>
      <Container maxWidth="xl">
        <WStateLayout
          title={t('orders.crossdocking.no_incomplete_orders', {
            ns: 'title',
          })}
          description={t('orders.crossdocking.no_incomplete_orders', {
            ns: 'description',
          })}
        >
          <UnpublishedIcon
            sx={{ fontSize: '100px', color: 'secondary.main' }}
          />
        </WStateLayout>
      </Container>
    </Paper>
  );
}
